import React, { useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { ShieldQuestion, X, ArrowRight } from "lucide-react";
import { useStore } from "@/lib/store";

// Gentle desktop-style alert that appears the moment an AI employee routes a
// decision to the Approval Center.
export function ApprovalPush() {
  const { state, clearPush } = useStore();
  const navigate = useNavigate();
  const push = state.push;
  const emp = push && state.employees.find((e) => e.id === push.employeeId);

  useEffect(() => {
    if (!push) return;
    const t = setTimeout(() => clearPush(), 8000);
    return () => clearTimeout(t);
  }, [push, clearPush]);

  return (
    <AnimatePresence>
      {push && (
        <motion.div
          initial={{ opacity: 0, y: -20, x: 20 }}
          animate={{ opacity: 1, y: 0, x: 0 }}
          exit={{ opacity: 0, y: -20 }}
          transition={{ type: "spring", stiffness: 260, damping: 24 }}
          className="glass-strong fixed right-4 top-4 z-[80] w-[330px] overflow-hidden rounded-2xl p-4 sm:right-6 sm:top-6"
          style={{ boxShadow: "0 0 0 1px rgba(255,191,0,0.35), 0 12px 40px rgba(0,0,0,0.5)" }}
          role="alert"
          data-testid="approval-push"
        >
          <div className="pointer-events-none absolute -right-10 -top-10 h-28 w-28 rounded-full" style={{ background: "radial-gradient(circle, rgba(255,191,0,0.25), transparent 70%)" }} />
          <div className="flex items-start gap-3">
            <span className="grid h-10 w-10 shrink-0 place-items-center rounded-xl bg-[#FFBF00]/15 text-[#FFBF00]"><ShieldQuestion size={18} /></span>
            <div className="min-w-0 flex-1">
              <div className="flex items-center gap-2 text-[11px] font-mono uppercase tracking-wide text-[#FFBF00]">
                Approval requested
                {emp && <img src={emp.avatar} alt={emp.name} className="h-4 w-4 rounded-full object-cover" />}
              </div>
              <div className="mt-0.5 text-sm font-medium text-white">{push.title}</div>
              <div className="text-[11px] text-slate-400">Prepared by {emp ? emp.name : push.employeeId} · needs your decision</div>
              <button
                onClick={() => { clearPush(); navigate("/approvals"); }}
                className="mt-2 flex items-center gap-1 text-xs font-semibold text-[#00E5FF]"
                data-testid="approval-push-open"
              >
                Open Approval Center <ArrowRight size={13} />
              </button>
            </div>
            <button onClick={clearPush} aria-label="Dismiss" data-testid="approval-push-close" className="text-slate-500 hover:text-white"><X size={16} /></button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
